import MasterCrud from "@/components/app/MasterCrud";
import { IDR } from "@/lib/api";

export default function Machines() {
  return (
    <MasterCrud
      endpoint="/machines"
      title="Mesin & Peralatan"
      fields={[
        { key: "code", label: "Kode", type: "text", required: true },
        { key: "name", label: "Nama Mesin", type: "text", required: true },
        { key: "hourly_rate", label: "Tarif per Jam (IDR)", type: "number", required: true },
        { key: "energy_cost_per_hour", label: "Biaya Energi per Jam (IDR)", type: "number" },
        { key: "description", label: "Deskripsi", type: "textarea" },
      ]}
      columns={[
        { key: "code", header: "Kode" },
        { key: "name", header: "Nama" },
        { key: "hourly_rate", header: "Tarif/Jam", align: "right", render: (r) => IDR(r.hourly_rate) },
        { key: "energy_cost_per_hour", header: "Energi/Jam", align: "right", render: (r) => IDR(r.energy_cost_per_hour) },
      ]}
    />
  );
}
